import { usePage } from '@inertiajs/vue3'
import { computed } from 'vue'

export const useFeatureFlags = () => {
  const page = usePage()

  const CRISP_ENABLED = computed(() => page.props.featureFlags.crispEnabled)
  const BONJORO_ENABLED = computed(() => page.props.featureFlags.bonjoroEnabled)
  const OPENAI_MATCHING_ENABLED = computed(
    () => page.props.featureFlags.openaiMatchingEnabled,
  )
  const COACHING_ENABLED = computed(
    () => page.props.featureFlags.coachingEnabled,
  )
  const HELP_REQUESTS_VOTING_ENABLED = computed(
    () => page.props.featureFlags.helpRequestsVotingEnabled,
  )
  const MENTORS_MATCHING_V2_ENABLED = computed(
    () => page.props.featureFlags.v2AiMatchingEnabled,
  )

  return {
    CRISP_ENABLED,
    BONJORO_ENABLED,
    OPENAI_MATCHING_ENABLED,
    MENTORS_MATCHING_V2_ENABLED,
    COACHING_ENABLED,
    HELP_REQUESTS_VOTING_ENABLED,
  }
}
